module.exports = __webpack_public_path__ + "img/skin-name-bg.f82a11a1.png";